<h3 mat-dialog-title class="title-layout">Variant Configuration </h3>
<div mat-dialog-content>
  <p style="font-size: 18px;" [style.color]="variantStatus == 'inactive' ? 'red' : 'black' ">
    Variant Status: {{variantStatus | uppercase}}<br> 
    {{variantMsg}}
  </p>
  <p>To define a pitch variant, either select a pre-existing one from the existing pitch variant list or create a new pitch variant. </p>

  <form [formGroup]="fg_VariantConfig" >

    <mat-label>Existing Pitch Variants</mat-label>
    <mat-form-field class="card-dialog">
      <mat-select id="existing-team" matInput cdkTextareaAutosize formControlName="f_ExistingVariant">
            <mat-option *ngFor="let variant of teamVariantList" [value]="variant">
                {{variant.variant_name}} <span *ngIf="variant.variant_id == baseVariantID">(Base)</span>
            </mat-option>
        </mat-select>
        <small *ngIf="teamVariantConfig.model_variants?.length" style="color: blue;opacity:0.6; size: small;"> {{ modelNamesText }} </small> 
    </mat-form-field>

    <mat-label>Create a new Pitch Variant<br></mat-label>
    <mat-label><small>Enter the name for your pitch variant. If no name is entered, the name will be a string of the models separated by a slash.</small></mat-label>
    <mat-form-field class="card-dialog">
      <mat-label>Variant Name</mat-label>
        <input id="variantname" matInput type="text" formControlName="f_VariantName" [ngClass]="{'faded': !isVariantNameDirty}" (blur)="onVariantNameBlur()" cdkTextareaAutosize>
        <small class="variant-error" *ngIf="this.currentVariantStatus.rename">
            Existing variant &nbsp;<b>{{currentVariantStatus.variant_name}}</b>&nbsp; is being renamed.
        </small>
      </mat-form-field>
    
    <mat-label><small>Select model variants to define the new pitch variant.</small></mat-label>
    <mat-form-field class="card-dialog">
      <mat-label>Select Models</mat-label>
        <mat-select [panelClass]="'custom-mat-select-panel'" id="type" matInput cdkTextareaAutosize formControlName="f_ModelVariants" multiple #variantSelect>
          <mat-select-trigger>
            <span *ngIf="variantSelect.value?.length > 0">
              {{ selectedModelsList.join('/') }}
            </span>
          </mat-select-trigger>
          
          <mat-option *ngFor="let model of modelVariantList" [value]="model">
            {{model.model_name}}
          </mat-option>
        </mat-select>
    </mat-form-field>
    <div *ngIf="fg_VariantConfig?.get('f_ModelVariants')?.invalid &&
        fg_VariantConfig?.get('f_ModelVariants')?.errors &&
        (fg_VariantConfig?.get('f_ModelVariants')?.dirty || fg_VariantConfig?.get('f_ModelVariants')?.touched)">
      <small class="error" *ngIf="fg_VariantConfig?.get('f_ModelVariants')?.hasError('required')">
        At least one Model Variant must be selected..
      </small>
    </div>

      <span *ngIf = "transferWork" style="color: red;">
        <p>
            <span style="font-weight:500;">On Submit, </span>active work from {{ transferFromVariant.variant_name }} will be transferred to the new variant, 
            {{ selectedModelsList.join('/') }}.<br><br>
            {{ transferFromVariant.variant_name }} will be removed from the pitch.
          </p>
      </span>


    
  </form>
</div>

<div mat-dialog-actions>
  <button  mat-button color="primary" (click)="onSubmit()">Submit</button>
  <button mat-button color="primary" *ngIf="variantsWithWork.length > 0" (click)="onReassign()">Reassign Active Work</button>
  <button mat-button color="primary" (click)="onAssignNonActive()">Edit Variant Status</button>
  <button mat-button (click)="onNoClick()">Cancel</button>
</div>

<div *ngIf="isBusy">
    <mat-spinner></mat-spinner>
</div>